
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.subscribe-box{
  font-family:var(--ff-dmsans);
  font-size:var(--fs-sm);
  background:var(--brand-secondary-4);
  display:flex;
  position:relative;
}

  @media (min-width: 768px){.subscribe-box{
    display:grid;
    grid-template-columns:50vw 50vw;
    grid-template-rows:1fr auto 1fr
}
  }

  .subscribe-box se-container{
    grid-area:2 / 1 / 3 / 3;
    display:flex;
    justify-content:flex-end;
  }

  .subscribe-box__content{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-8);
    padding:var(--spacing-5);
  }

  @media (min-width: 768px){

  .subscribe-box__content{
      padding-left:var(--space-s-4xl);
      width:50%
  }
    }

  .subscribe-box__image{
    display:none;
  }

  @media (min-width: 768px){

  .subscribe-box__image{
      grid-area:1 / 1 / 4 / 2;
      display:flex
  }
    }

  .subscribe-box__image img{
      width:100%;
      height:100%;
      object-fit:cover;
      aspect-ratio:16/9;
    }

  .subscribe-box--inline{
    display:flex;
    flex-direction:column;
    background:var(--brand-primary-1);
    color:var(--brand-neutral-white);
  }

  .subscribe-box--inline a{
      color:var(--brand-neutral-white);
      font-weight:var(--fw-extrabold);
    }

  .subscribe-box--inline se-container{
      grid-area:unset;
      display:flex;
      justify-content:stretch;
      width:auto;
      padding:0;
    }

  .subscribe-box--inline .subscribe-box__content{
      width:auto;
      padding:var(--spacing-5);
      gap:var(--spacing-5);
    }

  .subscribe-box--inline .subscribe-box__content p{
        margin:0;
      }

  @media (min-width: 768px){

  .subscribe-box--inline .subscribe-box__content{
        padding:var(--spacing-12) var(--spacing-8);
        gap:var(--spacing-5)
    }
      }
`;